<mat-form-field appearance="outline">
  <mat-label>Interval</mat-label>
  <mat-select (selectionChange)="optionChange($event)" [(ngModel)]="selectedOption">
    @for (option of dateIntervalOptions; track option) {
      <mat-option value="{{ option }}">
        {{ option }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>